export default function SectionHeading({ overline, title, subtitle, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {overline && <div className="overline mb-4">{overline}</div>}
      <h2 className="font-display text-3xl md:text-5xl uppercase leading-[1.05] text-white">
        {title}
      </h2>
      {subtitle && (
        <p className="text-[#AEB7B7] text-base md:text-lg mt-5 leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}
